import type { BaseItineraryBlockProps } from './BaseItineraryBlock.js';

import { isFlightUnavailable } from '#views/trip/bookings/booking-grouping.js';

import { BaseItineraryBlock } from './BaseItineraryBlock.js';

export function LayoverBlock({ event, items, size = 'default', className }: BaseItineraryBlockProps) {
  if (event.type !== 'layover') return null;

  // A layover shares its underlying item with the surrounding flight legs (the itinerary-expansion
  // engine stamps the same item across a connection's departure/arrival/layover events) — it mutes
  // whenever that flight is cancelled or sold out live, matching the legs around it. The event itself
  // carries no booking status of its own, so this reads the item directly rather than `event.bookingStatus`.
  const primaryItem = items[0];
  const bookingStatusOverride = primaryItem?.isCancelled
    ? ('cancelled' as const)
    : primaryItem && isFlightUnavailable(primaryItem) && primaryItem.isPlanned
      ? ('unavailable' as const)
      : undefined;

  if (size === 'sm') {
    return (
      <BaseItineraryBlock
        event={event}
        items={items}
        size={size}
        className={className}
        bookingStatusOverride={bookingStatusOverride}
      />
    );
  }

  return (
    <div
      data-print="compact-row"
      className="flex flex-col md:items-center py-8 md:py-12 px-4 md:px-8 border-b text-muted-foreground bg-background-secondary"
    >
      <BaseItineraryBlock
        event={event}
        items={items}
        size={'sm'}
        className={className}
        bookingStatusOverride={bookingStatusOverride}
      />
    </div>
  );
}
